module.exports = __webpack_public_path__ + "img/icon_saveextra.e08fae79.png";